<template>
  <!-- todo:为什么加了user-scalable就正常了 -->
  <div
    class="wrapper"
    id="hammerElement"
    style="background-color: midnightblue;"
  >
    <!--    调试用div层-->
    <!--    <div-->
    <!--      class="click-grid"-->
    <!--      style="background-color: transparent; position: fixed; z-index: 20;"-->
    <!--    >-->
    <!--      <div class="left" v-on:click="countReduce"></div>-->
    <!--      <div class="right" v-on:click="countPlus"></div>-->
    <!--    </div>-->

    <transition
      v-on:before-enter="enter"
      v-on:before-leave="leave"
      mode="out-in"
    >
      <div v-if="index === 0" class="page-wrapper">
        <start-page></start-page>
      </div>
    </transition>

    <transition
      v-on:before-enter="enter"
      v-on:before-leave="leave"
      :appear="true"
      mode="out-in"
    >
      <div v-if="index === 1" class="page-wrapper" style="overflow: hidden;">
        <student-info-page :is-first="pageFirst.get(1)"></student-info-page>
      </div>
    </transition>

    <transition
      v-on:before-enter="enter"
      v-on:before-leave="leave"
      :appear="true"
      mode="out-in"
    >
      <div v-if="index === 2" class="page-wrapper">
        <library-detail-page :is-first="pageFirst.get(2)"></library-detail-page>
      </div>
    </transition>

    <transition
      v-on:before-enter="enter"
      v-on:before-leave="leave"
      :appear="true"
    >
      <div v-if="index === 3" class="page-wrapper">
        <card-page :is-first="pageFirst.get(3)"></card-page>
      </div>
    </transition>

    <transition
      v-on:before-enter="enter"
      v-on:before-leave="leave"
      :appear="true"
    >
      <div v-if="index === 4" class="page-wrapper">
        <first-class-page :is-first="pageFirst.get(4)"></first-class-page>
      </div>
    </transition>

    <transition
      v-on:before-enter="enter"
      v-on:before-leave="leave"
      :appear="true"
    >
      <div v-if="index === 5" class="page-wrapper">
        <morning-class-page :is-first="pageFirst.get(5)"></morning-class-page>
      </div>
    </transition>

    <transition
      v-on:before-enter="enter"
      v-on:before-leave="leave"
      :appear="true"
    >
      <div v-if="index === 6" class="page-wrapper">
        <total-class-page :is-first="pageFirst.get(6)"></total-class-page>
      </div>
    </transition>

    <transition
      v-on:before-enter="enter"
      v-on:before-leave="leave"
      :appear="true"
    >
      <div v-if="index === 7" class="page-wrapper">
        <most-class-page :is-first="pageFirst.get(7)"></most-class-page>
      </div>
    </transition>
    <transition
      v-on:before-enter="enter"
      v-on:before-leave="leave"
      :appear="true"
    >
      <div v-if="index === 8" class="page-wrapper">
        <select-page :is-first="pageFirst.get(8)"></select-page>
      </div>
    </transition>

    <transition
      v-on:before-enter="enter"
      v-on:before-leave="leave"
      :appear="true"
    >
      <div v-if="index === 9" class="page-wrapper">
        <best-score-page :is-first="pageFirst.get(9)"></best-score-page>
      </div>
    </transition>

    <transition
      v-on:before-enter="enter"
      v-on:before-leave="leave"
      :appear="true"
    >
      <div v-if="index === 10" class="page-wrapper">
        <rewards-page :is-first="pageFirst.get(10)"></rewards-page>
      </div>
    </transition>

    <transition
      v-on:before-enter="enter"
      v-on:before-leave="leave"
      :appear="true"
    >
      <div v-if="index >= 11" class="page-wrapper">
        <end-page v-on:re-start="refresh"></end-page>
      </div>
    </transition>
  </div>
</template>

<script>
import StartPage from '@/components/pages/startPage'
import StudentInfoPage from '@/components/pages/stuInfo/studentInfoPage'
import LibraryDetailPage from '@/components/pages/library/libraryDetailPage'
import CardPage from '@/components/pages/card/cardPage'
import FirstClassPage from '@/components/pages/schedule/firstClassPage'
import MorningClassPage from '@/components/pages/schedule/morningClassPage'
import TotalClassPage from '@/components/pages/schedule/totalClassPage'
import MostClassPage from '@/components/pages/schedule/mostClassPage'
import SelectPage from '@/components/pages/select/selectPage'
import BestScorePage from '@/components/pages/select/bestScorePage'
import RewardsPage from '@/components/pages/rewards/RewardsPage'
import store from '@/store/store'
import EndPage from '@/components/pages/endPage'
import Hammer from 'hammerjs'
export default {
  name: 'showOut',
  components: {
    EndPage,
    RewardsPage,
    BestScorePage,
    SelectPage,
    MostClassPage,
    TotalClassPage,
    MorningClassPage,
    FirstClassPage,
    CardPage,
    LibraryDetailPage,
    StudentInfoPage,
    StartPage,
  },
  data() {
    return {
      index: 0,
      isLeft: true,
      //判断是否时第一次进入该页面的map(第一次需要有动画)
      pageFirst: new Map([
        [0, true],
        [1, true],
        [2, true],
        [3, true],
        [4, true],
        // [5, true],
        // [6, true],
        // [7, true],
        // [8, true],
        // [9, true],
        // [10, true],
        // [11, true],
      ]),
      // 使用vuex state中的数据判断该页面是否应该显示
      pageMap: new Map([
        [1, 'room'],
        [2, 'lead'],
        [3, 'seat'],
        // [4, 'Schedule'],
        // [5, 'Morning'],
        // [6, 'Schedule'],
        // [7, 'Schedule'],
        // [8, 'Select'],
        // [9, 'Select'],
        // [10, 'Rewards'],
      ]),
      animateClassList: [
        'animate__fadeInLeft',
        'animate__fadeInRight',
        'animate__fadeOutLeft',
        'animate__fadeOutRight',
      ],
    }
  },
  mounted() {
    window.addEventListener('resize', this.fitWindow, false)

    let el = document.getElementById('hammerElement')
    let hammerTime = new Hammer(el)
    let that = this
    hammerTime.on('swiperight', () => {
      that.countReduce()
    })
    hammerTime.on('swipeleft', () => {
      that.countPlus()
    })
  },
  methods: {
    // 如果介于16：10和20:9之间的屏幕就拉伸占满全屏
    // 如果不是这样的屏幕 就适应其中一边
    fitWindow() {
      let el = document.getElementById('hammerElement')
      let radio = window.innerHeight / window.innerWidth
      if (radio > 16 / 10 && radio < 20 / 9) {
        el.style.width = window.innerWidth + 'px'
        el.style.height = window.innerHeight + 'px'
      } else {
        let windowHeight = window.innerHeight
        let windowWidth = window.innerWidth
        if ((windowHeight / 16) * 9 < windowWidth) {
          el.style.height = windowHeight + 'px'
          el.style.width = (windowHeight / 16) * 9 + 'px'
        } else if ((windowWidth / 9) * 16 < windowHeight) {
          el.style.width = windowWidth + 'px'
          el.style.height = (windowWidth / 9) * 16 + 'px'
        }
      }
      document.getElementsByTagName('html')[0].style.fontSize =
        el.style.width.replace('px', '') / 25 + 'px'
    },
    refresh() {
      // 全部初始化
      for (let i = 0; i <= 11; i++) {
        this.pageFirst.set(i, true)
      }
      this.index = 0
    },
    countPlus() {
      this.pageFirst.set(this.index, false)
      let tempIndex = this.index
      if (tempIndex + 1 >= 1 && tempIndex + 1 <= 10) {
        tempIndex++
        while (
          this.isShowPage[this.pageMap.get(tempIndex)] !== true &&
          tempIndex + 1 <= 11
        ) {
          tempIndex++
        }
        this.index = tempIndex
        this.isLeft = false
      } else if (tempIndex + 1 === 11) {
        this.isLeft = false
        this.index++
      }
    },
    countReduce() {
      this.pageFirst.set(this.index, false)
      let tempIndex = this.index
      if (tempIndex - 1 >= 1 && tempIndex - 1 <= 10) {
        tempIndex--
        while (
          this.isShowPage[this.pageMap.get(tempIndex)] !== true &&
          tempIndex - 1 >= 0
        ) {
          tempIndex--
        }
        this.isLeft = true
        this.index = tempIndex
      } else if (tempIndex - 1 === 0) {
        this.isLeft = true
        this.index--
      }
    },
    //控制进入是播放的动画效果是从左边 还是从右边
    enter(el) {
      el.classList.remove(...this.animateClassList)
      if (this.isLeft === true) {
        el.classList.add('animate__animated', 'animate__fadeInLeft')
      } else {
        el.classList.add('animate__animated', 'animate__fadeInRight')
      }
    },
    leave(el) {
      el.classList.remove(...this.animateClassList)
      if (this.isLeft === true) {
        el.classList.add('animate__animated', 'animate__fadeOutRight')
      } else {
        el.classList.add('animate__animated', 'animate__fadeOutLeft')
      }
    },
  },
  computed: {
    isShowPage: function () {
      return store.state.isShowPage
    },
  },
  watch: {
    //控制background的彩蛋是否出现
    index: function (newVal) {
      if (newVal === 0) {
        store.commit('showTop')
      } else if (newVal === 11) {
        store.commit('showBottom')
      } else {
        store.commit('hideTop')
        store.commit('hideBottom')
      }
    },
  },
}
</script>

<style scoped>
/*调试用css class*/
.click-grid {
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 10fr 1fr;
  grid-template-areas:
    '.    .'
    'left right'
    '.    .';
}

.left {
  grid-area: left;
}

.right {
  grid-area: right;
}

.page-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}
</style>
